import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class IncomesService {

  // Get incomes list
  getIncomes = async (pageNum, search = '', limit = false, sortBy = 'name', sortOrder = 'asc', projectId = '', partnerId = '', yearFrom = '', yearTo = '') => {
    let url = `${API_URL}/incomes?page=${pageNum}&search=${search}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}`

    // Añadir projectId si existe
    if (projectId) {
      url += `&projectId=${projectId}`
    }   

    // Añadir los filtros de fecha si están presentes
    if (yearFrom) {
      url += `&yearFrom=${yearFrom}`
    }

    if (yearTo) {
      url += `&yearTo=${yearTo}`
    }

    return await axios.get(url, { headers: authHeader() })
  }

  // Add new income
  addIncome = async (income) => {
    return await axios.post(API_URL + '/incomes', income, { headers: authHeader() })
  }

  // Update income data
  updateIncome = async (income, id) => {
    return await axios.patch(API_URL + '/incomes/' + id, income, { headers: authHeader() })
  }

  // Get income data
  getIncome = async (id) => {
    return await axios.get(API_URL + '/incomes/' + id, { headers: authHeader() })
  }

  // Delete income
  deleteIncome = async (id) => {
    return await axios.delete(API_URL + '/incomes/' + id, { headers: authHeader() })
  }

  // Get incomes chart dataset
  getIncomesDataset = async ({ projectId = '', yearFrom = '', yearTo = '' }) => {

    const params = new URLSearchParams()
    if (projectId) params.append("projectId", projectId)
    if (yearFrom) params.append("yearFrom", yearFrom)
    if (yearTo) params.append("yearTo", yearTo)

    const url = `${API_URL}/dataset/incomes?${params.toString()}`

    return await axios.get(url, { headers: authHeader() })
  }

}

export default new IncomesService()